import { CommonMessages } from "../messages/validationMessages";
import * as Yup from "yup";

export const addBuyUpsSchema = Yup.object().shape({
  location: Yup.array()
    .required(CommonMessages.location_required)
    .min(1, "Select Location."),
  washname: Yup.string().required(CommonMessages.washname_required),
  buyupDetails: Yup.string().required(CommonMessages.washdetails_required),
  amount: Yup.string()
    .matches(/^\d{0,8}(\.\d{0,2})?$/, "Enter amount.")
    .required(CommonMessages.amount_required),
});

